












































































































































import Vue from 'vue';
import axios from 'axios';
import { get, orderBy } from 'lodash';
import { Event } from '@/types/GlobalTypes';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import EventBus from '@/eventBus';
import CoEvent from '@/components/Molecules/co-event/CoEvent.vue';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';

export default {
    name: 'MyEvents',
    computed: {
        // Hide the member create button when the space disables events globally.
        isEventsEnabled() {
            return !this.$store?.state?.space?.EventsOff;
        },
    },
    watch: {
        '$store.state.space.EventsOff': {
            handler(isEventsOff) {
                if (isEventsOff) {
                    this.redirectToEventNotFound();
                }
            },
            immediate: true,
        },
    },
    data() {
        return {
            events: [],
            pastEvents: [],
            me: this.$store.state.me,
            loading: false,
            pastLoading: false,
            thisSpaceID: get(this.$store, 'state.space.ID', ''),
            userProfiles: {},
            userProfilesPast: {},
            upcomingNextPage: null,
            pastNextPage: null,
        };
    },
    components: {
        CoText,
        CoHeadline,
        CoRoundButton,
        CoButton,
        CoCard,
        CoEvent,
        CoThumbnail,
    },
    mounted() {
        if (!this.isEventsEnabled) {
            return;
        }
        this.getMyEvents();
        this.getMyPastEvents();
    },
    methods: {
        get,
        // Redirect disabled event pages to the shared event 404 view.
        redirectToEventNotFound() {
            this.$router.replace('/not-found/event').catch(() => {});
        },
        getMyEvents() {
            this.loading = true;
            axios({
                method: 'GET',
                url: this.upcomingNextPage || 'event/list/my', // "/event/list/my?startFromID=Kzfx4kT6ws1ZCcoYeOnjuHpiQuF_q-7tos8Qejdb8CDg9GRrG2slUs_-xFCpUCVm2rQWcqKIOtlqTSn-D1IJRw=="
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(async (response) => {
                    const events = response.data?.Objects || [];
                    // handle pagination
                    this.upcomingNextPage = response.data?.Next || null;
                    // handle empty response
                    if (events?.length < 1) return;

                    //map user profiles to events and add to feed
                    let feedPage = [];
                    events.forEach((e) => {
                        if (!e.object || typeof e.object !== 'object') return;
                        let eventItem = e.object;
                        let amIattending = eventItem.Participants?.includes(this.me.ID) || false;
                        // // add organizers to participants list and map user profiles
                        e.object.Organizers = e.object.OrganizersProfiles || [];
                        // // aggregate participants and organizers profiles as one participants list
                        e.object.Participants = (e.object.ParticipantProfiles || []).concat(e.object.Organizers);
                        //add item to the feedPage
                        feedPage.push({
                            ...eventItem,
                            Images: eventItem.ImageURL ? [{ ImageURL: eventItem.ImageURL }] : null,
                            Attend: amIattending,
                        });
                    });
                    // sort events by start date ascending
                    feedPage = orderBy(feedPage, ['StartDate'], ['asc']);
                    //update the feed list
                    this.events = this.events.concat(feedPage);
                })
                .catch((error) => {
                    if (error.response && error.response.status !== 404) {
                        const msg = {
                            Message: 'Error while fetching events',
                            Details: '',
                        };
                        EventBus.$emit('ERROR', msg);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getMyPastEvents() {
            this.pastLoading = true;

            axios({
                method: 'GET',
                url: this.pastNextPage || 'event/list/my?past=true', // "/event/list/my?startFromID=Kzfx4kT6ws1ZCcoYeOnjuHpiQuF_q-7tos8Qejdb8CDg9GRrG2slUs_-xFCpUCVm2rQWcqKIOtlqTSn-D1IJRw==&past=true"
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(async (response) => {
                    const events = response.data?.Objects || [];
                    // handle pagination
                    this.pastNextPage = response.data?.Next || null;
                    // handle empty response
                    if (events?.length < 1) return;

                    //map user profiles to events and add to feed
                    let feedPage = [];
                    events.forEach((e) => {
                        if (!e.object || typeof e.object !== 'object') return;
                        let eventItem = e.object;
                        let amIattending = eventItem.Participants?.includes(this.me.ID) || false;
                        // // add organizers to participants list and map user profiles
                        e.object.Organizers = e.object.OrganizersProfiles || [];
                        // // aggregate participants and organizers profiles as one participants list
                        e.object.Participants = (e.object.ParticipantProfiles || []).concat(e.object.Organizers);
                        //add item to the feedPage
                        feedPage.push({
                            ...eventItem,
                            Images: eventItem.ImageURL ? [{ ImageURL: eventItem.ImageURL }] : null,
                            Attend: amIattending,
                        });
                    });
                    //update the feed list
                    this.pastEvents = this.pastEvents.concat(feedPage);
                })
                .catch((error) => {
                    if (error.response && error.response.status !== 404) {
                        const msg = {
                            Message: 'Error while fetching past events',
                            Details: '',
                        };
                        EventBus.$emit('ERROR', msg);
                    }
                })
                .finally(() => {
                    this.pastLoading = false;
                });
        },
    },
};
